export const EXPIRATION = 1;
export const EXPIRATION_DESCRIPTION = 'Fecha Vencimiento';
export const STOCK = 2;
export const STOCK_DESCRIPTION = 'Stock';